export default __webpack_public_path__ + "pdf/BusSchedule.29029d4.pdf";